
















































import CostFilter from "./filters/CostFilter.vue";
import DescriptionFilter from "./filters/DescriptionFilter.vue";
import ProjectFilter from "./filters/ProjectFilter.vue";
import ResourceFilter from "./filters/ResourceFilter.vue";
import StatusFilter from "./filters/StatusFilter.vue";
import TypeFilter from "./filters/TypeFilter.vue";

import Vue, { PropType } from "vue";
import { Component } from "vue-property-decorator";
import { RecommendationExtra } from "../store/model";

const FiltersRowProps = Vue.extend({
  props: {
    isMobile: {
      type: Boolean,
      required: true
    }
  }
});

@Component({
  components: {
    CostFilter,
    DescriptionFilter,
    ProjectFilter,
    ResourceFilter,
    StatusFilter,
    TypeFilter
  }
})
export default class FiltersRow extends FiltersRowProps {}
